import { gzipSync, gunzipSync } from "fflate"

export function compress(obj) {
    const json = JSON.stringify(obj)
    const compressed = gzipSync(new TextEncoder().encode(json))
    const result = Array.from(compressed)

    return result
}
export function decompress(smashed) {
    if (!smashed) {
        return null
    }
    const u8 = smashed instanceof Uint8Array ? smashed : new Uint8Array(smashed)
    const json = new TextDecoder().decode(gunzipSync(u8))
    return JSON.parse(json)
}

/**
 * @param hexKey
 * @param payload
 * @returns {Promise<string>}
 */
export async function encrypt(hexKey, payload) {
    if (typeof payload !== "string") {
        try {
            payload = JSON.stringify(payload)
        } catch (err) {
            throw err
        }
    }

    const key = await importKeyFromHex(hexKey, { name: "AES-GCM", length: 256 }, true, ["encrypt", "decrypt"])

    const encoded = new TextEncoder().encode(payload)
    const iv = crypto.getRandomValues(new Uint8Array(16))
    const encrypted = await crypto.subtle.encrypt(
        {
            name: "AES-GCM",
            iv,
        },
        key,
        encoded
    )

    return `${arrayBufferToHex(iv)}${arrayBufferToHex(encrypted)}`
}

/**
 * @param hexKey
 * @param str
 * @returns {Promise<any|string>}
 */
export async function decrypt(hexKey, str) {
    const ivPart = str.slice(0, 2 * 16)
    const encryptedPart = str.slice(2 * 16)
    const ivBuffer = hexToUint8Array(ivPart)
    const payloadBuffer = hexToUint8Array(encryptedPart)

    let key

    try {
        key = await importKeyFromHex(hexKey, { name: "AES-GCM", length: 256 }, true, ["encrypt", "decrypt"])
    } catch (e) {
        return null
    }
    if (!key) {
        return null
    }

    let decrypted = ""

    try {
        decrypted = await crypto.subtle.decrypt(
            {
                name: "AES-GCM",
                iv: ivBuffer,
            },
            key,
            payloadBuffer
        )
    } catch (e) {
        return null
    }

    const decoded = new TextDecoder().decode(decrypted)

    try {
        return JSON.parse(decoded)
    } catch (err) {
        return decoded
    }
}

function arrayBufferToHex(buffer) {
    const byteArray = new Uint8Array(buffer)
    let hexString = ""
    for (let i = 0; i < byteArray.length; i++) {
        const hex = byteArray[i].toString(16)
        hexString += (hex.length === 1 ? "0" : "") + hex
    }
    return hexString
}

function hexToUint8Array(hexString) {
    const bytes = []
    for (let i = 0; i < hexString.length; i += 2) {
        bytes.push(parseInt(hexString.slice(i, i + 2), 16))
    }
    return new Uint8Array(bytes)
}

async function importKeyFromHex(hexString, algorithm, extractable, usages) {
    const byteCharacters = []
    for (let i = 0; i < hexString.length; i += 2) {
        byteCharacters.push(parseInt(hexString.substr(i, 2), 16))
    }
    const keyMaterial = new Uint8Array(byteCharacters).buffer

    return crypto.subtle.importKey("raw", keyMaterial, algorithm, extractable, usages)
}
